namespace TerminalApp {
    export class Menu {
        constructor() {

        }
    }
}